import { Fragment } from "react";
import { formatHourFromTimestamp, formatSeconds } from "../../js/functions";

export function SolicitudesYRegistros({ solicitud, registro }) {
  const displayHoraInicioSolicitud = solicitud.inicio === undefined ? "none" : "block"
  const horaInicioSolicitud = displayHoraInicioSolicitud === "block" ? formatHourFromTimestamp(solicitud.inicio.toDate()) : null
  
  const displayHoraInicioRegistro = registro.inicio === undefined ? "none" : "block"
  
  const tiempoTotalSolicitud = setTiempoTotal(solicitud)
  const tiempoTotalRegistro = setTiempoTotal(registro)

  const modalidadRegistro = registro.teletrabajo !== undefined ? "Teletrabajo" : "Presencial"
  const modalidadSolicitud = solicitud.teletrabajo !== undefined ? "Teletrabajo" : "Presencial"
  
  let horaInicioRegistro = null
  if (registro !== undefined && registro.inicio !== undefined && registro.trabajado === true) {
    horaInicioRegistro = formatHourFromTimestamp(registro.inicio.toDate())
  }

  function setTiempoTotal(solicitudORegistro) {
    if(solicitudORegistro.trabajado === false) return solicitudORegistro.motivoLibre
    if(solicitudORegistro.inicio === undefined) return ""

    let pausas = "", totalSegundos = 0, total = "DIA SIN COMPLETAR";
    if (solicitudORegistro.pausas !== undefined && solicitudORegistro.pausas !== null) {
      if (solicitudORegistro !== "") {
        pausas = solicitudORegistro.pausas.filter(pausa => pausa.tipo !== 2)
      }
      else {
        pausas = "" 
      }
    } 

    if (pausas !== "" && pausas.length > 0 && solicitudORegistro.fin !== undefined && pausas !== null) {
      for (let i = 0; i<pausas.length; i++) {
        if (pausas[i] !== undefined) {
          if (pausas[i].fin !== undefined){
            if (pausas.length === 1) { //solo si hay 1 pausa
              const segundosAux = pausas[0].inicio.seconds - solicitudORegistro.inicio.seconds
              const segundosAux2 = solicitudORegistro.fin.seconds - pausas[0].fin.seconds
              totalSegundos = segundosAux + segundosAux2
              total = formatSeconds(totalSegundos)
              //console.log("una pausa")
            } else if (pausas.length === 2) { //hay 2 pausas
              const segundosAux = pausas[0].inicio.seconds - solicitudORegistro.inicio.seconds
              const segundosAux2 = pausas[1].inicio.seconds - pausas[0].fin.seconds
              const segundosAux3 = solicitudORegistro.fin.seconds - pausas[1].fin.seconds
              totalSegundos = segundosAux + segundosAux2 + segundosAux3
              total = formatSeconds(totalSegundos)
              //console.log("2 pausas")
            } else { // hay mas de 2 pausas
              if (i === 0) { //primera pausa
              const segundosAux = pausas[i].inicio.seconds - solicitudORegistro.inicio.seconds
              totalSegundos = totalSegundos + segundosAux
              //console.log("tres pausas 1, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundos)
              } else if (i < pausas.length) { //pausas intermedias
              const segundosAux = pausas[i].inicio.seconds - pausas[i-1].fin.seconds
              totalSegundos = totalSegundos + segundosAux
              //console.log("tres pausas 2, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundos)
              } 
              if(i === pausas.length-1) { //ultima pausa
              const segundosAux = solicitudORegistro.fin.seconds - pausas[i].fin.seconds
              totalSegundos = totalSegundos + segundosAux
              //console.log("tres pausas 3, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundos)
              total = formatSeconds(totalSegundos)
              }
            }
          }
        }
      }
    }
    else if (solicitudORegistro.fin !== undefined) {
      const totalSegundos = solicitudORegistro.fin.seconds - solicitudORegistro.inicio.seconds
      total = formatSeconds(totalSegundos)
    }
    if (solicitudORegistro === "" && total === "DIA SIN COMPLETAR") return ""
    return total
  }

  const displayHoraFinSolicitud = solicitud.fin === undefined ? "none" : "block"
  const horaFinSolicitud = displayHoraFinSolicitud === "block" ? formatHourFromTimestamp(solicitud.fin.toDate()) : null
  
  const displayHoraFinRegistro = registro.fin === undefined ? "none" : "block"
  // const horaFinRegistro = displayHoraFinRegistro === "block" ? formatHourFromTimestamp(solicitud.fin.toDate()) : null
  
  let horaFinRegistro = null
  if (registro !== undefined && registro.fin !== undefined && registro.trabajado === true) {
    horaFinRegistro = formatHourFromTimestamp(registro.fin.toDate())
  }

  const pausasSolicitud = []
  if (solicitud.pausas !== undefined && solicitud.pausas !== null) {
    solicitud.pausas.forEach(pausa => {
      let inicioPausa = formatHourFromTimestamp(pausa.inicio.toDate())

      if (pausa.fin !== undefined) {
        let finPausa = ""
        finPausa = formatHourFromTimestamp(pausa.fin.toDate())
        pausasSolicitud.push({
          nombre: `${inicioPausa} - ${finPausa}`,
          modalidad: pausa.teletrabajo !== undefined ? "Teletrabajo" : "Presencial"
        });
      }
      else {
        pausasSolicitud.push({
          nombre: `${inicioPausa}`,
          modalidad: pausa.teletrabajo !== undefined ? "Teletrabajo" : "Presencial"
        });
      }
    })
  }

  const pausasRegistro = []
  if (registro.pausas !== undefined && registro.pausas !== null) {
    registro.pausas.forEach(pausa => {
      let inicioPausa = formatHourFromTimestamp(pausa.inicio.toDate())

      if (pausa.fin !== undefined) {
        let finPausa = ""
        finPausa = formatHourFromTimestamp(pausa.fin.toDate())
        pausasRegistro.push({
          nombre: `${inicioPausa} - ${finPausa}`,
          modalidad: pausa.teletrabajo !== undefined ? "Teletrabajo" : "Presencial"
        });
      }
      else {
        pausasRegistro.push({
          nombre: `${inicioPausa}`,
          modalidad: pausa.teletrabajo !== undefined ? "Teletrabajo" : "Presencial"
        });
      }
    })
  }

  function cambiosPausas() {
    const longitudMaxima = Math.max(pausasSolicitud.length, pausasRegistro.length);
    const diferencias = [];

    for (let i = 0; i < longitudMaxima; i++) {
      const solicitud = pausasSolicitud[i] || { nombre: "✘", modalidad: "✘" };
      const registro = pausasRegistro[i] || { nombre: "✘", modalidad: "✘" };

      const nombreCambia = solicitud.nombre !== registro.nombre;
      const modalidadCambia = solicitud.modalidad !== registro.modalidad;

      if (nombreCambia || modalidadCambia) {
        diferencias.push({
          index: i,
          solicitud,
          registro,
          nombreCambia,
          modalidadCambia,
        });
      }
    }

    if (diferencias.length === 0) {
      return null;
    }

    return (
      <>
        {diferencias.map(({ index, solicitud, registro, nombreCambia, modalidadCambia }) => (
          <Fragment key={index}>
          <div className="horaAlgo">
            <span>Pausa {index + 1}:</span>
            <span>
              {
                nombreCambia
                  ? `${registro.nombre} → ${solicitud.nombre}`
                  : solicitud.nombre
              }
            </span>
          </div>
          <div className="horaAlgo marginbottom-8">
            <span></span>
            <span>
              {
                modalidadCambia
                  ? `${registro.modalidad} → ${solicitud.modalidad}`
                  : solicitud.modalidad
              }
            </span>
          </div>
          </Fragment>
        ))}
      </>
    );
  }

  function comprobarCambios(registroAux, solicitudAux, elemento) {
    const registroAux2 = registroAux === null ? "" : registroAux
    const solicitudAux2 = solicitudAux === null ? "" : solicitudAux

    if (registroAux2 === "DIA SIN COMPLETAR" && solicitudAux2 === "DIA SIN COMPLETAR") return "DIA SIN COMPLETAR"

    if (registroAux2 === "OTROS" && solicitudAux2 === "OTROS" && elemento === "tiempoTotal") return `OTROS: ${registro.comentarioLibre} → OTROS: ${solicitud.comentarioLibre}`
    if (registroAux2 === "OTROS" && elemento === "tiempoTotal") return `OTROS: ${registro.comentarioLibre} → ${solicitudAux2}`
    if (solicitudAux2 === "OTROS" && elemento === "tiempoTotal") return `${registroAux2} → OTROS: ${solicitud.comentarioLibre}`

    if (registro.trabajado === false && elemento !== "tiempoTotal") return `→ ${solicitudAux2}`
    if (solicitud.trabajado === false && elemento !== "tiempoTotal") return `${registroAux2} →`

    if (registroAux2 !== solicitudAux2) return `${registroAux2} → ${solicitudAux2}`
  }

  function comprobarCambiosModalidad(registroAux, solicitudAux) {
    if (registroAux !== solicitudAux) return `${registroAux} → ${solicitudAux}`
    if (registroAux === solicitudAux) return registroAux
  }

  function comprobarBaja(tiempoTotal, comentarioLibre) {
    if (tiempoTotal === "OTROS") return `OTROS: ${comentarioLibre}`
    return tiempoTotal
  }

  function comprobarCambiosInicio(horaRegistro, horaSolicitud, modalidadRegistro, modalidadSolicitud) {
    const horaCambia = horaRegistro !== horaSolicitud;
    const modalidadCambia = modalidadRegistro !== modalidadSolicitud;

    if (!horaCambia && !modalidadCambia) return null;

    return (
      <>
        <div className="horaAlgo">
          <span>Hora Inicio</span> <span>{horaCambia ? `${horaRegistro} → ${horaSolicitud}` : horaSolicitud}</span>
        </div>
        <div className="horaAlgo marginbottom-8">  
          <span></span> <span>{modalidadCambia ? `${modalidadRegistro} → ${modalidadSolicitud}` : modalidadSolicitud}</span>
        </div>
      </>
    );
  }

  return (
    <>
      <article className="flexsolicitudes">
        <div>

          {/* REGISTRO */}
          <div style={{textAlign: "center", marginBottom: "10px"}}>
            <strong>Registro</strong>
          </div>

          {registro !== "" && registro.trabajado === true &&
            <>
              <div style={{display: displayHoraInicioRegistro}} className="horaAlgo">
                <span>Hora inicio:&nbsp;</span> <span>{horaInicioRegistro}</span>
              </div>
              <div style={{display: displayHoraInicioRegistro}} className="horaAlgo marginbottom-8">
                <span></span> <span>{modalidadRegistro}</span>
              </div>

              {pausasRegistro.map((pausa, index) => (
                <Fragment key={index}>
                  <div className="horaAlgo">
                    <span>Pausa {index + 1}:&nbsp; </span> <span>{pausa.nombre}</span>
                  </div>
                  <div className="horaAlgo marginbottom-8">
                    <span>&nbsp; </span> <span>{pausa.modalidad}</span>
                  </div>
                </Fragment>
              ))}

              <div style={{display: displayHoraFinRegistro}} className="horaAlgo">
                <span>Hora fin:&nbsp; </span> <span>{horaFinRegistro}</span>
              </div>

              <div style={{marginTop: "10px"}} className="horaAlgo">
                <span>Tiempo total:&nbsp; </span> <span><strong>{comprobarBaja(tiempoTotalRegistro, registro.comentarioLibre)}</strong></span>
              </div>
            </>
          }

          {registro !== "" && registro.trabajado === false &&
            <>
              <div style={{display: "flex", alignItems: "start", justifyContent: "center", height: "25px"}} className="horaAlgo">
                <div>
                  <strong>{comprobarBaja(tiempoTotalRegistro, registro.comentarioLibre)}</strong>
                </div>
              </div>
            </>
          }

          {registro === "" && 
            <>
              <div style={{display: "flex", alignItems: "start", justifyContent: "center", height: "25px"}} className="horaAlgo">
                <div>
                  <strong>No existe registro</strong>
                </div>
              </div>
            </>
          }
        </div>

        {/* SOLICITUD */}
        <div>
          <div style={{textAlign: "center", marginBottom: "10px"}}>
            <strong>Solicitud</strong>
          </div>
          {solicitud.trabajado === true && 
            <>
              <div style={{display: displayHoraInicioSolicitud}} className="horaAlgo">
                <span>Hora inicio:&nbsp;</span> <span>{horaInicioSolicitud}</span>
              </div>
              <div style={{display: displayHoraInicioRegistro}} className="horaAlgo marginbottom-8">
                <span></span> <span>{modalidadRegistro}</span>
              </div>

              {pausasSolicitud.map((pausa, index) => (
                <Fragment key={index}>
                  <div className="horaAlgo">
                    <span>Pausa {index + 1}:&nbsp; </span> <span>{pausa.nombre}</span>
                  </div>
                  <div className="horaAlgo marginbottom-8">
                    <span>&nbsp; </span> <span>{pausa.modalidad}</span>
                  </div>
                </Fragment>
              ))}

              <div style={{display: displayHoraFinSolicitud}} className="horaAlgo">
                <span>Hora fin:&nbsp; </span> <span>{horaFinSolicitud}</span>
              </div>

              <div style={{marginTop: "10px"}} className="horaAlgo">
                <span>Tiempo total:&nbsp; </span> <span><strong>{comprobarBaja(tiempoTotalSolicitud, solicitud.comentarioLibre)}</strong></span>
              </div>
            </>
          }
          {solicitud.trabajado === false && 
            <>
              <div style={{display: "flex", alignItems: "start", justifyContent: "center", height: "25px"}} className="horaAlgo">
                <div>
                  <strong>{comprobarBaja(tiempoTotalSolicitud, solicitud.comentarioLibre)}</strong>
                </div>
              </div>
            </>
          }
          
        </div>

        {/* CAMBIOS */}
        <div id="cambiosSolicitudes">
          <div style={{textAlign: "center", marginBottom: "10px"}}>
            <strong>Cambios</strong>
          </div>

          {comprobarCambiosInicio(horaInicioRegistro, horaInicioSolicitud, modalidadRegistro, modalidadSolicitud)}

          {cambiosPausas()}

          <div style={{display: horaFinRegistro === horaFinSolicitud ? "none" : "block"}} className="horaAlgo">
            <span>Hora fin:&nbsp; </span> <span>{comprobarCambios(horaFinRegistro, horaFinSolicitud, "horaFin")}</span>
          </div>

          <div style={{marginTop: "10px"}} className="horaAlgo">
            <span>Tiempo total:&nbsp; </span> <span><strong>{comprobarCambios(tiempoTotalRegistro, tiempoTotalSolicitud, "tiempoTotal")}</strong></span>
          </div>
        </div>
      </article>
    </>
  )
}
